import React from 'react';
import './Convertor.css';

function Convertor() {
  return (
    <div>
      <div className="center">
        <h1> Convertor - Simplifiez vos calculs et conversions avec une seule application !</h1>
        <p>Que vous ayez besoin de convertir des devises lors de vos voyages (bientôt disponible), de mesurer des ingrédients pour une recette, ou retrouver des formules en mathématiques ou en physique, Convertor est là pour vous aider à accomplir vos tâches avec efficacité et précision.</p>
      </div>
      <div className="container">
        <h1>Fonctionnalités principales :</h1>
        <div className="image-container">
          <div className="image-wrapper">
            <p>......</p>
            <img src="convertor_conversions.png" alt="convertor_conversions.png" />
          </div>
          <div className="image-wrapper">
            <p>......</p>
            <img src="convertor_unités.png" alt="convertor_unites.png" />
          </div>
          <div className="image-wrapper">
            <p>......</p>
            <img src="convertor_géométrie.png" alt="convertor_geometrie.png" />
          </div>
          <div className="image-wrapper">
            <p>......</p>
            <img src="convertor_formules.png" alt="convertor_formules.png" />
          </div>
        </div>
      </div>
      <div className="center">
        <h1>Choisissez Convertor pour :</h1>
        <p>Convertir des longueurs , des températures , des masses et d'autres unités qui sont regroupées en un seul outil.</p>
        <p>Découvrir des unités d'autres pays du monde</p>
        <p>Un outil de calcul de formes géometriques avec des formules</p>
        <p>Convertor est régulièrement mis à jour avec de nouvelles fonctionnalités pour enrichir votre expérience mathématique.</p>
        <h1>Téléchargez Convertor disponible sur Android et prochainement sur iOS :</h1>
        <div className="container">
          <div className="image-container">
            <div className="image-wrapper">
              <a href="convertor_store_android">
                <img src="image_android.png" alt="Android" />
              </a>
            </div>
            <a href="convertor_store_ios">
              <img src="image_ios.png" alt="iOS" />
            </a>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Convertor;
